import React from "react";
import Button, { ButtonProps } from "@mui/material/Button";

type ButtonLinkProps = {
  children: React.ReactNode;
  size?: "small" | "medium" | "large" | "xs";
  variant?: "text" | "contained" | "outlined";
  width?: "xs" | "sm" | "md" | "lg" | "xl";
  disabled?: boolean;
};

const ButtonLink: React.FC<ButtonProps & ButtonLinkProps> = ({ children, size, variant, width, disabled, ...rest }) => {
  return (
    <Button
      size={size}
      color="primary"
      variant={variant ? variant : "contained"}
      fullWidth={width === "xs" || !width ? true : false}
      disableElevation
      type="button"
      sx={{ minWidth: "auto" }}
      disabled={disabled}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default ButtonLink;
